export { EOrderStatus, EResultOptions, EErrorCodes } from '@web-store-platforms/types';
import { EErrorCodes } from '@web-store-platforms/types';

export const ERROR_MESSAGES = {
    STORE_DOMAIN_REQUIRED: 'Store domain is required. Please set NEXT_PUBLIC_STORE_DOMAIN environment variable or ensure the request includes a valid Host header.',
} as const;


export const FAILED_PAGE_MESSAGES = {
    /** Matches store-frontend ShopPage campaign fallback: `/failed?msg=offer not found` */
    OFFER_NOT_FOUND: 'offer not found',
    CREATE_ORDER_ERROR: 'creating order error'
} as const;

/** Exact backend error body messages mapped to failed-page error codes */
export const BACKEND_ERROR_MESSAGES = {
    NO_REMAINING_AVAILABILITY: 'No remaining availability for this offer',
} as const;

export const BACKEND_MESSAGE_TO_ERROR_CODE: Record<string, EErrorCodes> = {
    [BACKEND_ERROR_MESSAGES.NO_REMAINING_AVAILABILITY]: EErrorCodes.GIFT_ALREADY_CLAIMED,
};
